/**
 * Sub1 Template
 * @category testApp
 */
class GetsearchresultTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     */
    static getSearchResultTempl(_d={}, _config={}) {
        let profileUrl = _config.profileImg;

        if(_d.list.length <1){
            return `
            <div class="no-result-wrap">
                <span class="no-result-thumb"></span>
                <strong class="no-result-alarm">검색 결과가 없습니다.</strong>
                <span class="no-result-text">검색어의 철자가 정확한지 확인해주세요.<br>검색어가 두 단어 이상일 경우, 띄어쓰기를 확인해주세요.</span>
            </div>    
            <p class="search-result-alarm">※ <em>최종 접속 시간이 1년 이상 지난 캐릭터</em>는 노출되지 않으니, 캐릭터 검색 시 참고하시기 바랍니다.</p>
            `;
        }
        else{
            let resultList = `<ul class="search-result-list">`;
            const options = _d.list.map(arrayItem => GetsearchresultTempl.getSearchResultItemTempl(arrayItem, profileUrl)).join('');
            resultList += options + `</ul>`;
            return `
            ${resultList}
            <div class="loading-wrap is-show">
                <div class="loading"></div>
            </div>
            <p class="search-result-alarm">※ <em>최종 접속 시간이 1년 이상 지난 캐릭터</em>는 노출되지 않으니, 캐릭터 검색 시 참고하시기 바랍니다.</p>
            `;
        }
    }

    static getSearchResultItemTempl(_d, _profileUrl){
        let profileImageUrl = _profileUrl + _d.profileImageUrl;
        return `
        <li>
            <a href="${_d.characterHomeUrl}" class="search-result-link">
                <span class="search-result-thumb">${_d.profileImageUrl ? `<img src="${profileImageUrl}" alt="">`: ``}</span>
                <div class="search-result-info">
                    <div class="character-name">${_d.highlightName}</div>
                    <div class="character-sub-info">
                        <span class="character-sub-info-text">${_d.className}</span>
                        <span class="character-sub-info-text">${_d.serverName}</span>
                        <span class="character-sub-info-text"><em>Lv.${_d.level}</em>${_d.masteryFactionName ? `<em>${_d.masteryFactionName}${_d.masteryLevel}성</em>`:``}</span>
                    </div>
                </div>
            </a>
        </li>
        `;
    }

} // end of class

export default GetsearchresultTempl;